/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown>, range: NonNullable<unknown> }} Wrapped_Period_Share_CalendarInputs */

const en_us2_wrapped_period_share_calendar = /** @type {(inputs: Wrapped_Period_Share_CalendarInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} training days in ${i?.range}. My Pocket Gym.`)
};

const pt_br2_wrapped_period_share_calendar = /** @type {(inputs: Wrapped_Period_Share_CalendarInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} dias de treino em ${i?.range}. My Pocket Gym.`)
};

const es_419_wrapped_period_share_calendar = /** @type {(inputs: Wrapped_Period_Share_CalendarInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} días de entrenamiento en ${i?.range}. My Pocket Gym.`)
};

const pt_pt2_wrapped_period_share_calendar = /** @type {(inputs: Wrapped_Period_Share_CalendarInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} dias de treino em ${i?.range}. My Pocket Gym.`)
};

const fr_fr2_wrapped_period_share_calendar = /** @type {(inputs: Wrapped_Period_Share_CalendarInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} jours d'entraînement en ${i?.range}. My Pocket Gym.`)
};

const de_de2_wrapped_period_share_calendar = /** @type {(inputs: Wrapped_Period_Share_CalendarInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} Trainingstage in ${i?.range}. My Pocket Gym.`)
};

const it_it2_wrapped_period_share_calendar = /** @type {(inputs: Wrapped_Period_Share_CalendarInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} giorni di allenamento in ${i?.range}. My Pocket Gym.`)
};

/**
* | output |
* | --- |
* | "{days} training days in {range}. My Pocket Gym." |
*
* @param {Wrapped_Period_Share_CalendarInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_share_calendar = /** @type {((inputs: Wrapped_Period_Share_CalendarInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Share_CalendarInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_share_calendar(inputs)
	if (locale === "es-419") return es_419_wrapped_period_share_calendar(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_share_calendar(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_share_calendar(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_share_calendar(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_share_calendar(inputs)
	return en_us2_wrapped_period_share_calendar(inputs)
});
export { wrapped_period_share_calendar as "wrapped-period.share_calendar" }